import { ApiError } from "../api";

/** Uploads a blog image (cover, author photo or an image in a post) as raw bytes. */
export async function uploadBlogImage(file: File): Promise<{ key: string; url: string }> {
  const response = await fetch("/api/office/blog/images", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/octet-stream" },
    body: file,
  });
  const data: unknown = await response.json().catch(() => null);
  if (!response.ok) {
    const error = (data ?? {}) as { code?: string; message?: string };
    throw new ApiError(
      response.status,
      error.code ?? "ERROR",
      error.message ?? "Görsel yüklenemedi. Tekrar dene.",
    );
  }
  return data as { key: string; url: string };
}
